<template>
  <div>
    <card 
      :title="$t('pages.session_confirm.labels.location_info')"
      v-if="location !== undefined">
      <el-row class="mb-4">
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.id") }}
            <p>{{ location.locationId }}</p>
          </label>
        </el-col>
        <el-col v-if="location.name" :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.name") }}
            <p>{{ location.name }}</p>
          </label>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.address") }}
            <p>{{ location.address }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.city") }}
            <p>{{ location.city }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.country") }}
            <p>{{ location.country }}</p>
          </label>
        </el-col>
      </el-row>
    </card>
    <card v-if="location === undefined" class="centered-content">
      <div>
        <p>{{ $t("pages.session_confirm.no_location") }}</p>
      </div>
    </card>

    <card v-if="tariff !== undefined && tariff.currency"
      :title="$t('pages.session_confirm.labels.tariff')"
      >
      <el-row class="mb-4">
        <el-col v-if="tariff.fixed_price > 0" :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.fixed_price") }}
            <p>{{ tariff_string.fixed_price }}</p>
          </label>
        </el-col>
        <el-col v-if="tariff.energy_price > 0" :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.energy_price") }}
            <p>{{ tariff_string.energy_price }}</p>
          </label>
        </el-col>
        <el-col v-if="tariff.time_price > 0" :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.session_confirm.labels.time_price") }}
            <p>{{ tariff_string.time_price }}</p>
          </label>
        </el-col>
      </el-row>
    </card>

    <div style="margin: 0 auto; text-align: center;" v-loading="loading">
      <el-button class="button" @click="start()" :round="true">
        {{ $t("pages.session_confirm.start_charging").toUpperCase()    }}
      </el-button>
    </div>
    <div style="margin: 0 auto; text-align: center; padding-bottom: 15px">
      <el-button class="button" @click="goBack()" :round="true">
        {{ $t("pages.session_confirm.go_back").toUpperCase()   }}
      </el-button>
    </div>

  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { getCurrency } from "../services/tariff/curencies";
const { mapMutations, mapGetters, mapActions } = createNamespacedHelpers(
  "session"
);

export default {
  data() {
    return {
      tariff: this.getTariff(),
      tariff_string: {
        fixed_price: undefined,
        energy_price: undefined,
        time_price: undefined
      },
      location: this.getLocation(),
      loading : undefined,
    };
  },
  async mounted() {
    this.$console("log", "preparing tariffs:");

    this.$console("log", JSON.stringify(this.tariff));

    this.tariff_string.fixed_price = (this.tariff.fixed_price).toFixed(2)+ " " + getCurrency(this.tariff.currency),
    this.$console("log", "this.tariff_string.fixed_price = " + this.tariff_string.fixed_price);
    this.tariff_string.energy_price = (this.tariff.energy_price).toFixed(2)+ " " + getCurrency(this.tariff.currency) + "/kWh",
    this.$console("log", "this.tariff_string.energy_price = " + this.tariff_string.energy_price);
    this.tariff_string.time_price = (this.tariff.time_price).toFixed(2)+ " " + getCurrency(this.tariff.currency) + "/min"
    this.$console("log", "this.tariff_string.time_price = " + this.tariff_string.time_price);
  },
  methods: {
    ...mapGetters([
      "getTariff",
      "getLocation",
      "getSessionToken"
    ]),
    ...mapMutations(["changeStatusToActive"]),
    ...mapActions(["getSession", "getCommand", "stopSession", "startSession"]),
    async start() {
      try {
        const location = this.getLocation();

        this.loading = true;

        // Call start session command
        let response = await this.startSession({
          ...location,
          token: this.getSessionToken()
        });

        this.$console("log", "GET START RESPONSE:");
        this.$console("log", response);

        if (response.status === 200 && response.data.data.code === 3004) {
          // Flag that the command has been sent
          this.$store.commit("session/setCommandSent"); 

          this.$router.replace({
            name: "AdHocSession",
            params: {
              reload: false
            }
          });
        }
        else if (response.status === 200 && response.data.data.response.result === "ACCEPTED") {
          // Flag that the command has been sent
          this.$store.commit("session/setCommandSent"); 
          
          // get command uid
          this.$console("log", response.headers["command-uid"]);
          let commandUid = response.headers["command-uid"];

          const snooze = ms => new Promise(resolve => setTimeout(resolve, ms));
          // wait for it to be accepted
          let count = 5;
          while (count >= 1) {
            let commandResponse = await this.getCommand(commandUid)

            if (commandResponse.status === 200 ) {
              if (commandResponse.data.data.result.result.result === "ACCEPTED") {
                // redirect to session page
                this.$router.replace({
                  name: "AdHocSession",
                  params: {
                    reload: false
                  }
                });
                break
              }
              else if (commandResponse.data.data.result.result.result == "WAITING") {
                //do nothing, next cycle
              }
              else {
                this.loading = false
                this.$message({
                  type: "error",
                  message:
                    this.$t(`enum.errors.${commandResponse.data.data.result.code}`)
                });
                break
              }
            }
            await snooze(10000);
            count--;
          }
          if (count == 0) {
            this.loading = false
            this.$message({
              type: "error",
              message:
                this.$t(`enum.errors.${commandResponse.data.data.result.code}`)
            });
          }
        } else {
          this.loading = false
          let message = "enum.errors." + response.data.data.code
          this.$message({
            type: "error",
            message: `${this.$t('pages.session_confirm.not_started')} ${this.$t(message)}`
          });
        }
      } catch (e) {
        this.loading = false;
        this.$message({
          type: "error",
          message: this.$t('pages.session_confirm.not_started')
        });
      }
    },
    goBack(){
      this.$router.replace({
        name: "EvsePicker",
        params: {
          reload: false
        }
      });        
    },
  },
};
</script>
<style>

</style>